import OrderPayout from "../../../views/OrderPayout";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import React from "react";
import { Redirect } from "react-router-dom";

const OrderPayoutRoutes = [
  {
    menuName: MenuNames.ORDER_PAYOUT,
    path: "/order-payout",
    component: OrderPayout,
    exact: true,
  },
  {
    menuName: MenuNames.ORDER_PAYOUT,
    path: "/order-payout/:filter_type/:filter_value",
    component: OrderPayout,
    exact: true,
  },
  {
    menuName: MenuNames.ORDER_PAYOUT,
    path: "/order-payout/:business_type/:filter_type/:filter_value",
    component: OrderPayout,
    exact: true,
  },
];

export default OrderPayoutRoutes;
